module.exports = __webpack_public_path__ + "media/images/phone-e575aa7399f1090ac9274c53c4d62033.svg";